import { useDispatch } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import style from './ManageCard.module.scss';
import { Col, Form, Row } from 'react-bootstrap';
import Button from '../../../../common/Button/Button';
import InputFormik from '../../../../common/Formik/Input/InputFormik';
import {
    cardDetailsAction,
    getCardControlsAction,
    getGlobalCardSettingsAction,
    updateManagecardAction
} from '../../../../../features/user/userSlice';
import {
    EditNewIcon,
    MerchantcardIcon,
    OnlinecardIcon,
    TapcardIcon,
    TickIcon2
} from '../../../../../assets/icons/svgicons';
import { useNavigate } from 'react-router-dom';

const ManageCard = () => {
    const divideNo = 100000000;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const initialLimitsRef = useRef({});
    const initialCardControlsRef = useRef({});
    const [limits, setLimits] = useState({});
    const [loading, setLoading] = useState(false);
    const [btnchange, setBtnchange] = useState(null);
    const cardType = localStorage.getItem("cardType");
    const [limitErrors, setLimitErrors] = useState({});
    const [cardDetails, setCardDetails] = useState({});
    const [cardControls, setCardControls] = useState({});
    const [globalAdminDetails, setGlobalAdminDetails] = useState({});

    /* ===================== DATA CONFIG ===================== */

    const managecarddata = [
        { adminKey: "posTransactions", Icons: <MerchantcardIcon />, titletag: "Merchant Outlet", maxvalue: "$2,740.50" },
        { adminKey: "onlineTransactions", Icons: <OnlinecardIcon />, titletag: "Online", maxvalue: "$2,740.50" },
        { adminKey: "contactLessNfcPayments", Icons: <TapcardIcon />, titletag: "Tap and Pay", maxvalue: "$2,740.50" },
        { adminKey: "atmWithdrawals", Icons: <MerchantcardIcon />, titletag: "ATM Withdrawal", maxvalue: "$2,740.50" },
        { adminKey: "internationalTransactions", Icons: <OnlinecardIcon />, titletag: "International", maxvalue: "$2,740.50" },
        { adminKey: "domesticTransactions", Icons: <OnlinecardIcon />, titletag: "Domestic", maxvalue: "$2,740.50" },
    ];

    /* ===================== HANDLERS ===================== */

    const handleSwitchChange = (key) => {
        setCardControls((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    /* ===================== API CALLS ===================== */

    const getCardDetails = async () => {
        const res = await dispatch(cardDetailsAction());
        if (res?.status === 200) {
            const cards = res?.data?.data || [];
            setCardDetails({
                debit: cards.find((c) => c.card_type === "DEBIT"),
                credit: cards.find((c) => c.card_type === "CREDIT"),
            });
        }
    };

    const cardId =
        cardType === "CREDIT"
            ? cardDetails?.credit?.rain_card_id
            : cardDetails?.debit?.rain_card_id;

    const getCardControls = async () => {
        try {
            const res = await dispatch(getCardControlsAction(cardId));
            if (res?.status === 200 || res?.status === 201) {
                const d = res?.data?.data;
                const controls = {
                    atmWithdrawals: d?.atm_withdrawals,
                    contactLessNfcPayments: d?.contactless_nfc_payments,
                    domesticTransactions: d?.domestic_transactions,
                    internationalTransactions: d?.international_transactions,
                    posTransactions: d?.pos_transactions,
                    onlineTransactions: d?.online_transactions,
                };

                const limitsData = {
                    atmWithdrawals: d?.atm_withdrawal_limit / divideNo || "",
                    contactLessNfcPayments: d?.tap_and_pay_limit / divideNo || "",
                    domesticTransactions: d?.domestic_transaction_limit / divideNo || "",
                    internationalTransactions: d?.international_transaction_limit / divideNo || "",
                    posTransactions: d?.merchant_outlet_limit / divideNo || "",
                    onlineTransactions: d?.online_limit / divideNo || "",
                };

                setCardControls(controls);
                setLimits(limitsData);
                initialCardControlsRef.current = controls;
                initialLimitsRef.current = limitsData;
            }
        } catch (error) {
            console.log(error, "Error");
        }

    };

    const getGlobalCardDetails = async () => {
        const res = await dispatch(getGlobalCardSettingsAction(cardType));
        if (res?.status === 200 || res?.status === 201) {
            const d = res?.data?.data;
            setGlobalAdminDetails({
                atmWithdrawals: d?.atm_withdrawals,
                contactLessNfcPayments: d?.contactless_nfc_payments,
                domesticTransactions: d?.domestic_transactions,
                internationalTransactions: d?.international_transactions,
                posTransactions: d?.pos_transactions,
                onlineTransactions: d?.online_transactions,
            });
        }
    };

    /* ===================== EFFECTS ===================== */

    useEffect(() => {
        getCardDetails();
        getGlobalCardDetails();
    }, []);

    useEffect(() => {
        if (cardId) getCardControls();
    }, [cardId]);

    /* ===================== ADMIN FILTER ===================== */

    const filteredManageCardData = managecarddata.filter(
        (item) => globalAdminDetails?.[item.adminKey] === true
    );

    /* ===================== UPDATE MANAGE CARD ===================== */
    const updateManageCard = async () => {
        setLoading(true)
        try {
            const payload = {
                international_transactions: !!cardControls.internationalTransactions,
                domestic_transactions: !!cardControls.domesticTransactions,
                online_transactions: !!cardControls.onlineTransactions,
                atm_withdrawals: !!cardControls.atmWithdrawals,
                contactless_nfc_payments: !!cardControls.contactLessNfcPayments,
                pos_transactions: !!cardControls.posTransactions,

                international_transaction_limit: Number(limits.internationalTransactions || 0),
                domestic_transaction_limit: Number(limits.domesticTransactions || 0),
                online_limit: Number(limits.onlineTransactions || 0),
                atm_withdrawal_limit: Number(limits.atmWithdrawals || 0),
                tap_and_pay_limit: Number(limits.contactLessNfcPayments || 0),
                merchant_outlet_limit: Number(limits.posTransactions || 0),
            };

            const res = await dispatch(updateManagecardAction(payload, cardId));
            if (res?.status === 200 || res?.status === 201) {
                navigate("/auth/stbl-money")
            }
            else {
                console.log(res?.message, "API ERROR");
            }
        } catch (error) {
            console.log(error, "error");
        } finally {
            setLoading(false)
        }
    };

    /* ===================== FOR DISABLE UPDATE BUTTON  ===================== */
    const hasChanges = () => {
        for (const key in cardControls) {
            if (cardControls[key] !== initialCardControlsRef.current[key]) {
                return true;
            }
        }
        for (const key in limits) {
            if (
                String(limits[key] || "") !==
                String(initialLimitsRef.current[key] || "")
            ) {
                return true;
            }
        }
        return false;
    };

    /* ===================== JSX ===================== */
    return (
        <section className={style.manageCard}>
            <div className={style.manageCard_innerCard}>
                <h4>Card Controls</h4>

                <Row>
                    {filteredManageCardData.map((items) => (
                        <Col lg={6} md={6} sm={12} key={items.adminKey}>
                            <div className={style.manageCard_swtichfield}>
                                <div className={style.manageCard_swtichfield_head}>
                                    <div className={style.manageCard_swtichfield_head_lefttag}>
                                        <span className={style.tagIcon}>{items.Icons}</span>
                                        <h6>{items.titletag}</h6>
                                    </div>

                                    <div className={style.fieldswitch}>
                                        <Form.Check
                                            type="switch"
                                            id={`custom-switch-${items.adminKey}`}
                                            checked={!!cardControls?.[items.adminKey]}
                                            onChange={() => handleSwitchChange(items.adminKey)}
                                        />
                                    </div>
                                </div>

                                {cardControls?.[items.adminKey] && (
                                    <div className={style.manageCard_swtichfield_valueBottom}>
                                        <div className={style.manageCard_swtichfield_valueBottom_leftlimit}>
                                            <h6>Current Limit</h6>
                                            <div className={style.editField}>
                                                <span className={style.iconfield}>$</span>
                                                <InputFormik
                                                    placeholder="0"
                                                    className={style.input}
                                                    value={limits?.[items.adminKey]}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (!/^\d*$/.test(value)) return;
                                                        if (value === "") {
                                                            setLimits((prev) => ({
                                                                ...prev,
                                                                [items.adminKey]: "",
                                                            }));
                                                            setLimitErrors((prev) => ({
                                                                ...prev,
                                                                [items.adminKey]: "",
                                                            }));
                                                            return;
                                                        }
                                                        // MAX LIMIT = 100000
                                                        if (+value > 100000) {
                                                            setLimitErrors((prev) => ({
                                                                ...prev,
                                                                [items.adminKey]: "Maximum limit allowed is 100000",
                                                            }));
                                                            return;
                                                        }
                                                        setLimits((prev) => ({
                                                            ...prev,
                                                            [items.adminKey]: value,
                                                        }));
                                                        setLimitErrors((prev) => ({
                                                            ...prev,
                                                            [items.adminKey]: "",
                                                        }));
                                                    }}

                                                />
                                                {limitErrors?.[items.adminKey] && (
                                                    <small style={{ color: "red" }}>
                                                        {limitErrors[items.adminKey]}
                                                    </small>
                                                )}

                                                {/* <Button
                                                    className={style.editbtn}
                                                    variant="without_bg_border"
                                                    onClick={() =>
                                                        setBtnchange(
                                                            btnchange === items.adminKey ? null : items.adminKey
                                                        )
                                                    }
                                                >
                                                    {btnchange === items.adminKey ? (
                                                        <span className={style.checkIcon}><TickIcon2 /></span>
                                                    ) : (
                                                        <span className={style.editIcon}><EditNewIcon /></span>
                                                    )}
                                                </Button> */}
                                            </div>
                                        </div>
                                        {/* <div className={style.manageCard_swtichfield_valueBottom_rightmax}>
                                            <h6>Max. Limit</h6>
                                            <p>{items.maxvalue}</p>
                                        </div> */}
                                    </div>
                                )}
                            </div>
                        </Col>
                    ))}
                </Row>
                {filteredManageCardData.length > 0 ? (
                    <Button
                        className={style.btn_Size}
                        disabled={!hasChanges() || loading}
                        onClick={updateManageCard}
                    >
                        {loading ? "Loading ..." : "Update"}
                    </Button>
                ) : (
                    <div className={style.serviceDisabledMessage}>
                        <p>Card services are temporarily disabled by the administrator.</p>
                    </div>
                )}
            </div>
        </section>
    );
};

export default ManageCard;
